import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@weretradeit/ui-react';
// Style layering, in order:
//   1. design-system v3 — Token UND Bauteilklassen (.app-shell, .card, .btn …).
//      v3/base.css zieht compat/v2-aliases.css selbst mit, die v2-Namen in
//      ./styles.css loesen also weiter auf.
//   2. App-eigene Regeln.
// `@weretradeit/ui-react/src/styles.css` (0.4.0) ist ersatzlos entfallen: 4.x
// liefert kein src/ und kein CSS mehr aus; die Zeile waere ein Baufehler.
import '@weretradeit/design-system/v3/base.css';
import App from './App';
import { APP_KEY } from './config';
import './styles.css';

/* Die GlyphField-Szene wird hier NICHT importiert: App.tsx laedt sie nach dem
   Einhaengen im Leerlauf (glyphScene.ts, Begruendung dort). */

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Die aeussere Grenze faengt, was in der Huelle selbst bricht: die 500
        der Flotte mit Kennung (GlyphErrorPage kind="500"). Ohne `fallback` —
        ein `fallback` gewaenne vor `appKey` und verdeckte die Fehlerseite. */}
    <ErrorBoundary appKey={APP_KEY}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
